import { gql } from "@apollo/client";

export const GET_CUSTOMER_DETAILS = gql`
  query accountChipQuery {
    customer {
      email
      firstname
      lastname
      is_subscribed
    }
  }
`;

export default {
  getCustomerDetails: GET_CUSTOMER_DETAILS,
};
